export default {
  scrollBehavior: function (to, _, savedPosition) {
    // Priority 1: Hash navigation (highest priority)
    if (to.hash) {
      const element = document.getElementById(to.hash.replace(/#/, ""));
      if (element && element.scrollIntoView) {
        element.scrollIntoView({ block: "center", behavior: "smooth" });
      }
      return {
        el: to.hash,
      };
    }
    
    // Priority 2: Check for product card restoration context
    // If product context exists, disable package restoration to let custom system handle it
    if (typeof window !== 'undefined' && process.client) {
      try {
        const productContext = sessionStorage.getItem('lastClickedProduct');
        if (productContext) {
          const context = JSON.parse(productContext);
          // Check if context is valid and for homepage/store pages
          if (context && (context.portalPage === 'homepage' || context.portalPage === 'store')) {
            const age = Date.now() - (context.timestamp || 0);
            const maxAge = 60 * 60 * 1000; // 1 hour
            if (age < maxAge) {
              // Product context exists, return null to prevent package restoration
              // Custom product restoration will handle it
              return null;
            }
          }
        }
      } catch (error) {
        // If error reading context, continue with normal flow
        console.warn('Error checking product context:', error);
      }
    }
    
    // Priority 3: Let nuxt-scroll-restoration package handle savedPosition
    // The package will handle savedPosition automatically, so we can return it
    // or return null to let package handle it completely
    if (savedPosition) {
      // Return savedPosition - package will handle restoration
      return savedPosition;
    }
    
    // Priority 4: Default behavior for new pages
    // Return null to let package handle, or { top: 0 } for immediate scroll to top
    return null; // Let package handle default behavior
  },
};
